import { render, staticRenderFns } from "./companyStation.vue?vue&type=template&id=e4c602c8&scoped=true&"
import script from "./companyStation.vue?vue&type=script&lang=js&"
export * from "./companyStation.vue?vue&type=script&lang=js&"
import style0 from "./companyStation.vue?vue&type=style&index=0&id=e4c602c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c602c8",
  null
  
)

export default component.exports